import React from 'react';
import DepartmentWorkPlanner from '../../components/DepartmentWorkPlanner';

const HRWorkPlanner = () => {
  return <DepartmentWorkPlanner department="hr" departmentName="HR & Admin Department" />;
};

export default HRWorkPlanner;
